import {Component, Input, OnInit} from '@angular/core';
import {BranchUnitStruct} from "./BranchUnitStruct";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {sprintf} from "sprintf-js";
import {BranchMeasurement} from "../../CardStruct";

@Component({
  selector: 'app-branch-type-unit-overview',
  templateUrl: './branch-type-unit-overview.component.html',
  styleUrls: ['./branch-type-unit-overview.component.css']
})
export class BranchTypeUnitOverviewComponent implements OnInit {
  @Input() branchUnitOverview: BranchUnitStruct | undefined;

  ecdosagemeasurement: &VariableValue = new VariableValue();
  ecdosagesetpoint: &VariableValue = new VariableValue();

  ecsupplymeasurement: &VariableValue = new VariableValue();
  ecsupplysetpoint: &VariableValue = new VariableValue();

  phmeasurement: &VariableValue = new VariableValue();
  phsetpoint: &VariableValue = new VariableValue();

  flowmeasurement: &VariableValue = new VariableValue();
  flowsetpoint: &VariableValue = new VariableValue();

  mrx_adrpomps: &VariableValue = new VariableValue();
  mrx_noggeven: &VariableValue = new VariableValue();
  mrx_adrgifte: &VariableValue = new VariableValue();
  mrx_adrzstat: &VariableValue = new VariableValue();


  constructor(private variableDB: VariableDataBase) { }



  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  GetUnitStatus(variable: VariableValue) :string {
    if (variable.IsInvalid())
      return "--";
    switch (variable.val) {
      case 6622:
        return "discharge";
      case 6609:
        return "Fertilizing";
      case 5727:
        return "Standby";
      case 1800:
        return "Unit";
      case 6611:
        return "Paused";
      case 6612:
        return "Not active";
      case 6614:
        return "Active";
      case 1513:
        return "Wait on ebb";
      default:
        return "Unknown";
    }
  }



  ngOnInit(): void {
    if( this.branchUnitOverview ) {
      this.ecdosagemeasurement = this.variableDB.AddValueByReference(this.branchUnitOverview.ecdosagemeasurement.variable.id);
      this.ecdosagesetpoint = this.variableDB.AddValueByReference(this.branchUnitOverview.ecdosagesetpoint.variable.id);
      this.ecsupplymeasurement = this.variableDB.AddValueByReference(this.branchUnitOverview.ecsupplymeasurement.variable.id);
      this.ecsupplysetpoint = this.variableDB.AddValueByReference(this.branchUnitOverview.ecsupplysetpoint.variable.id);
      this.phmeasurement = this.variableDB.AddValueByReference(this.branchUnitOverview.phmeasurement.variable.id);
      this.phsetpoint = this.variableDB.AddValueByReference(this.branchUnitOverview.phsetpoint.variable.id);
      this.flowmeasurement = this.variableDB.AddValueByReference(this.branchUnitOverview.flowmeasurement.variable.id);
      this.flowsetpoint = this.variableDB.AddValueByReference(this.branchUnitOverview.flowsetpoint.variable.id);
      this.mrx_adrpomps = this.variableDB.AddValueByReference(this.branchUnitOverview.mrx_adrpomps.variable.id);
      this.mrx_noggeven = this.variableDB.AddValueByReference(this.branchUnitOverview.mrx_noggeven.variable.id);
      this.mrx_adrgifte = this.variableDB.AddValueByReference(this.branchUnitOverview.mrx_adrgifte.variable.id);
      this.mrx_adrzstat = this.variableDB.AddValueByReference(this.branchUnitOverview.mrx_adrzstat.variable.id);
    }
  }


}
